import BodyCard from "../../components/BodyCard";
import Section from "../../components/Section";
import PublicationsContent from "../../components/Publications";

export default function Publications() {
  return (
    <BodyCard>
      <Section noDivider content={<PublicationsContent />} />
    </BodyCard>
  );
}
